/* Product page 4a v2: gallery, quantity and volume pricing, variants, the
   Specifications table, the questions, the 3D link, the related products.
   Markup: sections/lb-pdp.liquid, sections/lb-pdp-below.liquid. */
(function () {
  var root = document.querySelector('[data-lb-pdp]');
  if (!root) return;
  var $ = function (s, r) { return (r || root).querySelector(s); };
  var $$ = function (s, r) { return [].slice.call((r || root).querySelectorAll(s)); };

  function moneyFmt(tpl, cents) {
    var n = (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return tpl.replace(/<[^>]*>/g, '').replace(/[\d.,]+/, n);
  }
  var MONEY = root.dataset.money || '$123,456.00';
  var MONEY_CUR = root.dataset.moneyCur || MONEY;

  /* ---- copy SKU ---- */
  root.addEventListener('click', function (e) {
    var b = e.target.closest('[data-lb-copy-sku]'); if (!b) return;
    var el = $('[data-lb-sku]'), txt = el ? el.textContent.trim() : '';
    var done = function () { b.classList.add('is-done'); b.title = 'Copied'; setTimeout(function () { b.classList.remove('is-done'); b.title = 'Copy SKU'; }, 1500); };
    if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(txt).then(done, function () {});
    else { var ta = document.createElement('textarea'); ta.value = txt; document.body.appendChild(ta); ta.select(); try { document.execCommand('copy'); done(); } catch (x) {} ta.remove(); }
  });

  /* ---- gallery ---- */
  (function () {
    var imgs = $$('.lb-gal__img'), thumbs = $$('.lb-gal__thumb'), dots = $$('.lb-gal__dots i');
    if (!imgs.length) return;
    var cur = 0;
    function show(i) {
      cur = (i + imgs.length) % imgs.length;
      imgs.forEach(function (im, k) { im.classList.toggle('is-on', k === cur); });
      thumbs.forEach(function (t, k) {
        t.classList.toggle('is-on', k === cur);
        if (k === cur && t.parentNode.scrollTo) t.parentNode.scrollTo({ left: Math.max(0, t.offsetLeft - t.parentNode.offsetLeft - (t.parentNode.clientWidth - t.offsetWidth) / 2), behavior: 'smooth' });
      });
      dots.forEach(function (d, k) { d.classList.toggle('is-on', k === cur); });
    }
    root.addEventListener('click', function (e) {
      if (e.target.closest('[data-lb-prev]')) show(cur - 1);
      else if (e.target.closest('[data-lb-next]')) show(cur + 1);
      else { var t = e.target.closest('.lb-gal__thumb'); if (t) show(+t.dataset.i); }
    });
    root.__lbShow = show;

    /* ---- full screen: click the picture ---- */
    var box = null, lbi = 0;
    function lbShow(i) {
      lbi = (i + imgs.length) % imgs.length;
      box.querySelector('.lb-lightbox__img').src = imgs[lbi].currentSrc || imgs[lbi].src;
      box.querySelector('.lb-lightbox__img').alt = imgs[lbi].alt;
      box.querySelector('.lb-lightbox__n').textContent = (lbi + 1) + ' / ' + imgs.length;
      [].forEach.call(box.querySelectorAll('.lb-lightbox__t'), function (t, k) { t.classList.toggle('is-on', k === lbi); });
    }
    function lbClose() {
      if (!box) return;
      document.removeEventListener('keydown', lbKey);
      document.documentElement.classList.remove('lb-lightbox-on');
      box.remove(); box = null;
    }
    function lbKey(e) {
      if (e.key === 'Escape') lbClose();
      else if (e.key === 'ArrowLeft') lbShow(lbi - 1);
      else if (e.key === 'ArrowRight') lbShow(lbi + 1);
    }
    function lbOpen(i) {
      box = document.createElement('div');
      box.className = 'lb-lightbox';
      box.setAttribute('role', 'dialog'); box.setAttribute('aria-modal', 'true'); box.setAttribute('aria-label', 'Product images');
      var many = imgs.length > 1;
      box.innerHTML = '<button type="button" class="lb-lightbox__x" aria-label="Close">&times;</button>' +
        (many ? '<button type="button" class="lb-lightbox__a lb-lightbox__a--p" aria-label="Previous image">&lsaquo;</button><button type="button" class="lb-lightbox__a lb-lightbox__a--n" aria-label="Next image">&rsaquo;</button>' : '') +
        '<div class="lb-lightbox__stage"><img class="lb-lightbox__img" alt=""></div>' +
        (many ? '<div class="lb-lightbox__bar"><span class="lb-lightbox__n"></span><div class="lb-lightbox__ts">' +
          imgs.map(function (im, k) { return '<button type="button" class="lb-lightbox__t" data-k="' + k + '" aria-label="Image ' + (k + 1) + '"><img src="' + (thumbs[k] ? thumbs[k].querySelector('img').src : im.src) + '" alt=""></button>'; }).join('') + '</div></div>' : '');
      document.body.appendChild(box);
      document.documentElement.classList.add('lb-lightbox-on');
      box.addEventListener('click', function (e) {
        if (e.target.closest('.lb-lightbox__x') || e.target.classList.contains('lb-lightbox__stage') || e.target === box) lbClose();
        else if (e.target.closest('.lb-lightbox__a--p')) lbShow(lbi - 1);
        else if (e.target.closest('.lb-lightbox__a--n')) lbShow(lbi + 1);
        else { var t = e.target.closest('.lb-lightbox__t'); if (t) lbShow(+t.dataset.k); }
      });
      document.addEventListener('keydown', lbKey);
      lbShow(i);
      box.querySelector('.lb-lightbox__x').focus();
    }
    var main = $('[data-lb-gal-main]');
    if (main) main.addEventListener('click', function (e) {
      if (e.target.closest('.lb-gal__arrow')) return;
      lbOpen(cur);
    });
    if (main) main.style.cursor = 'zoom-in';
  })();

  /* ---- Specifications: the description's list becomes the table ---- */
  (function () {
    var desc = $('[data-lb-desc]');
    if (!desc) return;
    var hs = $$('h3', desc);
    for (var i = 0; i < hs.length; i++) {
      if (!/^specifications$/i.test(hs[i].textContent.trim())) continue;
      var ul = hs[i].nextElementSibling;
      if (!ul || ul.tagName !== 'UL') return;
      var wrap = document.createElement('div');
      wrap.className = 'lb-spec';
      var h2 = document.createElement('h2'); h2.textContent = 'Specifications';
      var t = document.createElement('div'); t.className = 'lb-spec__t';
      [].forEach.call(ul.children, function (li) {
        var s = li.querySelector('strong, b');
        var row = document.createElement('div'); row.className = 'lb-spec__r';
        var b = document.createElement('b'), v = document.createElement('span');
        if (s) {
          b.textContent = s.textContent.replace(/:\s*$/, '');
          var clone = li.cloneNode(true); var cs = clone.querySelector('strong, b'); cs.remove();
          v.textContent = clone.textContent.trim();
        } else { v.textContent = li.textContent.trim(); }
        row.appendChild(b); row.appendChild(v); t.appendChild(row);
      });
      wrap.appendChild(h2); wrap.appendChild(t);
      hs[i].remove(); ul.remove();
      desc.parentNode.insertBefore(wrap, desc.nextSibling);
      break;
    }
  })();

  /* ---- questions: the edited list kept on Learn (src/data/faq.ts there) ---- */
  (function () {
    var box = $('[data-lb-faq]');
    if (!box || !window.fetch) return;
    var list = $('.lb-faq__list', box), allBtn = $('[data-lb-faq-all]', box), ask = $('[data-lb-ask]', box);
    var SHOWN = 5;
    function esc(t) { var d = document.createElement('div'); d.textContent = t; return d.innerHTML; }
    function pick(items) {
      var groups = {};
      items.forEach(function (f) { (groups[f.tier] = groups[f.tier] || []).push(f); });
      var out = [];
      Object.keys(groups).map(Number).sort(function (a, b) { return b - a; }).forEach(function (t) {
        var g = groups[t];
        for (var i = g.length - 1; i > 0; i--) { var j = Math.floor(Math.random() * (i + 1)); var x = g[i]; g[i] = g[j]; g[j] = x; }
        out = out.concat(g);
      });
      return out;
    }
    function draw(items, first) {
      list.innerHTML = items.map(function (f, i) {
        var open = first && i === 0;
        return '<div class="lb-faq__item' + (open ? ' is-open' : '') + '" data-id="' + esc(f.id) + '"><button type="button" class="lb-faq__q" aria-expanded="' + open + '"><span>' + esc(f.q) + '</span><span class="lb-faq__sign">' + (open ? '&minus;' : '+') + '</span></button><div class="lb-faq__a">' +
          f.a.split(/\n\n+/).map(function (p) { return '<p>' + esc(p) + '</p>'; }).join('') + '</div></div>';
      }).join('');
    }
    fetch('https://learn.lonelybinary.com/store-faq.json').then(function (r) { return r.ok ? r.json() : {}; })
      .then(function (map) {
        var hit = map[root.dataset.handle];
        if (!hit || !hit.faqs || !hit.faqs.length) return;
        var ranked = pick(hit.faqs);
        draw(ranked.slice(0, SHOWN), true);
        if (ranked.length > SHOWN) {
          allBtn.textContent = 'Show all ' + ranked.length + ' questions'; allBtn.hidden = false;
          allBtn.addEventListener('click', function () { draw(ranked, false); allBtn.hidden = true; });
        }
        if (hit.ask) { ask.href = hit.ask; ask.hidden = false; }
        box.hidden = false;
        box.addEventListener('click', function (e) {
          var q = e.target.closest('.lb-faq__q');
          if (!q) return;
          var item = q.parentNode, open = !item.classList.contains('is-open');
          [].forEach.call(box.querySelectorAll('.lb-faq__item'), function (it) {
            it.classList.remove('is-open');
            it.querySelector('.lb-faq__q').setAttribute('aria-expanded', 'false');
            it.querySelector('.lb-faq__sign').innerHTML = '+';
          });
          if (open) {
            item.classList.add('is-open'); q.setAttribute('aria-expanded', 'true'); q.querySelector('.lb-faq__sign').innerHTML = '&minus;';
            if (window.umami && window.umami.track) window.umami.track('faq-open', { id: item.dataset.id, code: hit.code });
          }
        });
      }).catch(function () {});
  })();

  /* ---- quantity, volume pricing, the button's label ---- */
  var qtyEl = $('.lb-qty__v'), vol = $('[data-lb-volume-pricing]'), nudge = $('[data-lb-vol-nudge]');
  var addBtn = $('.lb-atc__btn'), priceEl = $('[data-lb-price]');
  var cart = { count: 0, subtotal: 0 }, FAR = 5;
  var variants = [];
  try { variants = JSON.parse($('[data-lb-variants]', document).textContent); } catch (e) {}
  var variant = null;
  var vid = $('[data-lb-variant-id]');
  variants.forEach(function (v) { if (vid && String(v.id) === vid.value) variant = v; });
  var unitCents = variant ? variant.price : (vol ? +vol.dataset.price : 0);
  var available = variant ? variant.available : true;

  function qty() { return Math.max(1, parseInt(qtyEl && qtyEl.value, 10) || 1); }
  function tiers() {
    return vol ? vol.dataset.tiers.split(',').map(function (s) { var a = s.split(':'); return { qty: +a[0], pct: +a[1] }; }) : [];
  }
  function update() {
    if (!qtyEl) return;
    var q = qty(), total = cart.count + q, order = cart.subtotal + q * unitCents;
    var best = null, next = null;
    tiers().forEach(function (t) { if (total >= t.qty) best = t; else if (!next) next = t; });
    $$('.lb-vol__row').forEach(function (row) { row.classList.toggle('is-active', !!best && +row.dataset.qty === best.qty); });
    if (nudge) {
      var parts = [];
      if (best) parts.push('You get ' + best.pct + '% off your whole order, saving ' + moneyFmt(MONEY_CUR, Math.round(order * best.pct / 100)) + '.');
      if (next) {
        var gap = next.qty - total;
        parts.push('Add ' + gap + ' more for ' + next.pct + '% off and save ' + moneyFmt(MONEY_CUR, Math.round((order + gap * unitCents) * next.pct / 100)) + ' in all.');
      } else if (best) { /* best price unlocked */ }
      if (parts.length && cart.count > 0) parts.push('(Counting the ' + cart.count + ' already in your cart.)');
      nudge.textContent = parts.join(' ');
    }
    if (addBtn && available) {
      var line = Math.round(unitCents * q * (best ? (100 - best.pct) / 100 : 1));
      var label = 'Add to cart · ' + moneyFmt(MONEY, line);
      addBtn.textContent = label;
      addBtn.setAttribute('data-add-to-cart-text', label);
    }
    var bar = document.querySelector('.lb-buybar__btn');
    if (bar && available) bar.textContent = addBtn ? addBtn.textContent : 'Add to cart';
  }
  function setQty(n) {
    qtyEl.value = Math.max(1, n);
    qtyEl.dispatchEvent(new Event('change', { bubbles: true }));
    update();
  }
  root.addEventListener('click', function (e) {
    if (e.target.closest('[data-lb-inc]')) setQty(qty() + 1);
    else if (e.target.closest('[data-lb-dec]')) setQty(qty() - 1);
    else { var row = e.target.closest('.lb-vol__row'); if (row) setQty(+row.dataset.qty); }
  });
  if (qtyEl) { qtyEl.addEventListener('input', update); qtyEl.addEventListener('change', update); }
  function refreshCart() {
    fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); })
      .then(function (c) { cart.count = c.item_count; cart.subtotal = c.original_total_price; update(); }).catch(function () {});
  }
  document.addEventListener('submit', function (e) {
    if (e.target.matches && e.target.matches('form[action*="/cart/add"]')) setTimeout(refreshCart, 1500);
  });
  window.addEventListener('pageshow', refreshCart);
  update(); refreshCart();

  /* ---- variants ---- */
  var opts = $('[data-lb-opts]');
  if (opts && variants.length) {
    opts.addEventListener('change', function () {
      var chosen = $$('.lb-opt', opts).map(function (f) { var c = f.querySelector('input:checked'); return c ? c.value : null; });
      var hit = variants.filter(function (v) { return chosen.every(function (c, i) { return v.options[i] === c; }); })[0];
      if (!hit) return;
      variant = hit; unitCents = hit.price; available = hit.available;
      vid.value = hit.id;
      var skuEl = $('[data-lb-sku]'); if (skuEl && hit.sku) skuEl.textContent = hit.sku;
      if (priceEl) priceEl.textContent = moneyFmt(MONEY, hit.price);
      if (vol) vol.dataset.price = hit.price;
      $$('.lb-vol__row').forEach(function (row) {
        $('.lb-vol__price', row).textContent = moneyFmt(MONEY_CUR, Math.round(hit.price * (100 - +row.dataset.pct) / 100)) + ' each';
      });
      var stock = $('[data-lb-stock]');
      if (stock) stock.innerHTML = '<span class="lb-stock__dot' + (available ? '' : ' is-out') + '"></span>' + (available ? '<b>In stock</b> &middot; ships within one business day' : '<b>Sold out</b>');
      if (addBtn) { addBtn.disabled = !available; if (!available) addBtn.textContent = 'Sold out'; }
      if (hit.featured_media && root.__lbShow) {
        var imgs = $$('.lb-gal__img');
        imgs.forEach(function (im, k) { if (im.src && hit.featured_image && im.src.split('?')[0].split('/').pop().replace(/_\d+x.*$/, '') === String(hit.featured_image.src || '').split('?')[0].split('/').pop().replace(/_\d+x.*$/, '')) root.__lbShow(k); });
      }
      try { var u = new URL(location.href); u.searchParams.set('variant', hit.id); history.replaceState(null, '', u); } catch (e) {}
      update();
    });
  }

  /* ---- 3D link: Learn knows which boards have a 3D model ---- */
  var three = $('[data-three-link]');
  if (three && window.fetch) {
    fetch('https://learn.lonelybinary.com/shop-links.json').then(function (r) { return r.ok ? r.json() : {}; })
      .then(function (map) {
        var hit = map[root.dataset.handle];
        if (!hit || !hit.three) return;
        three.href = hit.three + '?utm_source=store&utm_medium=product_page';
        three.hidden = false;
      }).catch(function () {});
  }

  /* ---- related products ----
     The same family first, from the works:<family> tag (one per product): an ESP32-C3 product shows
     every other ESP32-C3 product, S3 the S3 ones, ESP32 the classic ones. A product with no such tag
     falls back to Shopify's own suggestions. */
  var rel = document.querySelector('[data-lb-related]');
  var FAMILIES = [
    ['works:ESP32-S3', 'More for the ESP32-S3', 'Boards, bases and bundles for the ESP32-S3.'],
    ['works:ESP32-C3', 'More for the ESP32-C3', 'The OLED board, its three bases and the set.'],
    ['works:ESP32', 'More for the ESP32', 'Boards, bases and bundles for the ESP32.']
  ];
  function tagsOf(p) { var t = p && p.tags; return Array.isArray(t) ? t : (t ? String(t).split(/,\s*/) : []); }
  function sameFamily() {
    var root_ = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    return fetch(root_ + 'products/' + root.dataset.handle + '.js')
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (me) {
        var mine = tagsOf(me), fam = null;
        FAMILIES.some(function (f) { if (mine.indexOf(f[0]) > -1) { fam = f; return true; } });
        if (!fam) return null;
        return fetch(root_ + 'collections/boards/products.json?limit=250')
          .then(function (r) { return r.ok ? r.json() : { products: [] }; })
          .then(function (d) {
            var list = (d.products || []).filter(function (q) {
              var t = tagsOf(q);
              return q.handle !== root.dataset.handle && t.indexOf(fam[0]) > -1;
            }).map(function (q) {
              var v0 = (q.variants || [])[0] || {};
              return {
                title: q.title, url: root_ + 'products/' + q.handle,
                featured_image: (q.images && q.images[0]) ? q.images[0].src : '',
                variants: q.variants, price: Math.round(parseFloat(v0.price || 0) * 100),
                available: (q.variants || []).some(function (v) { return v.available; })
              };
            });
            /* Whole rows of four only: the grid's grey background would show through a short row. */
            var n = list.length >= 4 ? Math.min(8, Math.floor(list.length / 4) * 4) : list.length;
            return list.length ? { products: list.slice(0, n), fam: fam } : null;
          });
      }).catch(function () { return null; });
  }
  function recommended() {
    return fetch('/recommendations/products.json?product_id=' + root.dataset.productId + '&limit=4&intent=related')
      .then(function (r) { return r.ok ? r.json() : { products: [] }; });
  }
  if (rel && window.fetch) {
    sameFamily().then(function (hit) { return hit || recommended(); })
      .then(function (d) {
        var list = (d.products || []).slice(0, 8); if (!list.length) return;
        if (d.fam) { rel.querySelector('h2').textContent = d.fam[1]; rel.querySelector('.lb-sub').textContent = d.fam[2]; }
        var grid = rel.querySelector('.lb-related__grid');
        grid.innerHTML = list.map(function (p) {
          var img = p.featured_image ? p.featured_image.replace(/(\.[a-z]+)(\?|$)/i, '_600x$1$2') : '';
          var t = document.createElement('div'); t.textContent = p.title;
          var v = (p.variants || [])[0] || {}, multi = (p.variants || []).length > 1;
          var cartSvg = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="9" cy="20" r="1.4"/><circle cx="18" cy="20" r="1.4"/><path d="M2 3h3l2.6 12.2a1 1 0 0 0 1 .8h8.8a1 1 0 0 0 1-.8L20 7H6"/></svg>';
          var btn = multi || !v.id
            ? '<a class="lb-pcard__add" href="' + p.url + '" aria-label="Choose options">' + cartSvg + '</a>'
            : '<button type="button" class="lb-pcard__add" data-vid="' + v.id + '" aria-label="Add to cart"' + (p.available === false ? ' disabled' : '') + '>' + cartSvg + '</button>';
          return '<div class="lb-pcard"><a class="lb-pcard__link" href="' + p.url + '"><div class="lb-pcard__img">' + (img ? '<img src="' + img + '" alt="" loading="lazy">' : '') + '</div><div class="lb-pcard__b"><div class="lb-pcard__n">' + t.innerHTML + '</div></div></a><div class="lb-pcard__f"><span class="lb-pcard__p">' + moneyFmt(MONEY, p.price) + '</span>' + btn + '</div></div>';
        }).join('');
        rel.hidden = false;
        grid.addEventListener('click', function (e) {
          var b = e.target.closest('button.lb-pcard__add'); if (!b || b.disabled) return;
          b.disabled = true;
          fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: +b.dataset.vid, quantity: 1 }) })
            .then(function (r) { if (!r.ok) throw 0; b.classList.add('is-done'); refreshCart(); })
            .catch(function () {})
            .then(function () { setTimeout(function () { b.disabled = false; b.classList.remove('is-done'); }, 1500); });
        });
      }).catch(function () {});
  }
})();
